import * as types from "../types";

const initialState = {
  loading: false,
  sim: null,
  requestDevice: null,
  error: null,
};

export default function simStatusReducer(state = initialState, action) {
  switch (action.type) {
    case types.SIM_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
        requestDevice: action.payload.requestDevice,
      };

    case types.SIM_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        sim: action.payload.sim,
      };

    case types.SIM_STATUS_FAILURE:
      return {
        ...state,
        loading: false,
        sim: null,
        requestDevice: null,
        error: action.payload.error,
      };

    default:
      return state;
  }
}
